import { css, StyleSheet } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { Pill } from '../../../web/components-v2/Pill';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';
import { PhoneIcon } from '../../../web/components/svgs/icons/PhoneIcon';
import { usePhoneCallOutcomeColorsQuery } from '../../../queries/PhoneCall/usePhoneCallOutcomeColorsQuery';
import { ILeadInteraction } from '../../viewModels/leads/interfaces';
import { hexToPillColor } from './hexToPillColor';

interface IProps {
	interaction?: ILeadInteraction;
	datePrefix?: string;
}

export const OutcomePill: React.FC<IProps> = ({ interaction, datePrefix }) => {
	const { data: outcomeColors } = usePhoneCallOutcomeColorsQuery();
	if (!interaction?.outcome || !interaction.date) {
		return <span className={css(styleSheet.muted)}>No interactions yet</span>;
	}
	const date = moment(interaction.date).format('ddd, MM/DD/YY, h:mmA');
	return (
		<div className={css(styleSheet.outcome)}>
			<Pill
				variant='label'
				color={hexToPillColor(interaction.outcome.hexColor || outcomeColors?.get(interaction.outcome.name))}
				label={interaction.outcome.name}
				icon={<PhoneIcon width={12} height={12} fill='currentColor' />}
			/>
			<span className={css(styleSheet.mutedSmall)}>{datePrefix ? `${datePrefix} ${date}` : date}</span>
		</div>
	);
};

const styleSheet = StyleSheet.create({
	muted: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	mutedSmall: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	outcome: {
		alignItems: 'flex-start',
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
	},
});
